export type WebGpuIssue = 'missing-api' | 'no-adapter' | 'probe-failed' | 'timed-out' | 'insecure';
export type WebGpuProbe = { available: true; adapter: any } | { available: false; issue: WebGpuIssue };

/** Adapter availability, not a performance or crash-free guarantee. Never leave entry waiting forever. */
export async function probeWebGpu(
  gpu = navigator.gpu,
  secureContext = window.isSecureContext !== false,
  timeoutMs = 6000,
): Promise<WebGpuProbe> {
  if (!secureContext) return { available: false, issue: 'insecure' };
  if (!gpu) return { available: false, issue: 'missing-api' };
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race<WebGpuProbe>([
      Promise.resolve().then(() => gpu.requestAdapter()).then(adapter => adapter ?
        { available: true as const, adapter } : { available: false as const, issue: 'no-adapter' as const }),
      new Promise<WebGpuProbe>(resolve => { timer = setTimeout(() => resolve({ available: false, issue: 'timed-out' }), timeoutMs); }),
    ]);
  } catch (_) {
    return { available: false, issue: 'probe-failed' };
  } finally {
    if (timer) clearTimeout(timer);
  }
}
